import ListSections from './ListSections.view';

export default ListSections;
